import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="careers-application-form"
export default class extends Controller {
  static targets = ["file", "fileName", "submit"];

  showFileName() {
    const file = this.fileTarget.files[0];
    if (file) this.fileNameTarget.textContent = file.name;
  }

  disableSubmit() {
    this.submitTarget.disabled = true;
    this.submitTarget.textContent = this.submitTarget.dataset.disableWithText;
  }
}
